import * as CoreUtils from "./helpers.js";
var Selector = function Selector(obj) {
  var parentNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (typeof obj == "string") {
    return Selector.resolve_string_to_object(obj, parentNode);
  } else if (CoreUtils.isElement(obj)) {
    return obj;
  } else {
    return {};
  }
};
Selector.prototype = Selector.__proto__ = {};
Selector.resolve_string_to_object = function (string, parentNode) {};
export { Selector };